import type { ThemeMetadata } from './types';

export const atelier: ThemeMetadata = {
  name: 'atelier',
  label: 'Atelier',
  vibe: 'Héritage, tradition, fierté du savoir-faire BTP. Pour les fratries historiques.',
  preview: {
    background: '#FAFAF7',
    surface: '#FFFFFF',
    accent: '#C8501E',
  },
};
